import { SolanaAugmentedProvider } from "@saberhq/solana-contrib";
export class SailBatchProvider extends SolanaAugmentedProvider {
    provider;
    loader;
    fetcher;
    constructor(provider, loader) {
        super(provider);
        this.provider = provider;
        this.loader = loader;
        this.fetcher = new SailBatchFetcher(loader);
    }
    async getAccountInfo(accountId) {
        const data = await this.loader.load(accountId);
        if (!data) {
            return null;
        }
        return {
            accountId,
            accountInfo: data,
        };
    }
}
export class SailBatchFetcher {
    loader;
    constructor(loader) {
        this.loader = loader;
    }
    async getAccountInfo(accountId) {
        const data = await this.loader.load(accountId);
        if (!data) {
            return null;
        }
        return {
            accountId,
            accountInfo: data,
        };
    }
}
//# sourceMappingURL=batchProvider.js.map